import type { CredentialFormField } from "@api/shared-runtime/credential-form-descriptors";
import { LICENSE_TYPE_LABELS } from "@api/shared-runtime/credential-vocabularies";

/** Nested personal details have their own fields; the shared descriptor only
 * covers the flat details used by both provider and organization forms. */
export const PERSONAL_INFO_FIELD_GROUPS = [
  {
    key: "name",
    label: "Name",
    fields: [
      { key: "first", label: "First name", kind: "text" },
      { key: "middle", label: "Middle name", kind: "text" },
      { key: "last", label: "Last name", kind: "text" },
      { key: "suffix", label: "Suffix", kind: "text" },
    ],
  },
  {
    key: "professional",
    label: "Professional details",
    fields: [
      { key: "providerRole", label: "Professional role", kind: "text" },
      {
        key: "providerType",
        label: "Provider type",
        kind: "select",
        options: Object.entries(LICENSE_TYPE_LABELS)
          .map(([value, label]) => ({ value, label }))
          .sort((left, right) => left.label.localeCompare(right.label)),
      },
      { key: "nuccGrouping", label: "Professional grouping", kind: "text" },
      { key: "specialtyCodes", label: "Specialties", kind: "string-list" },
      { key: "practiceSetting", label: "Practice setting", kind: "text" },
      {
        key: "primaryPracticeState",
        label: "Primary practice state",
        kind: "state",
      },
      {
        key: "additionalPracticeStates",
        label: "Additional practice states",
        kind: "string-list",
      },
      { key: "languages", label: "Languages", kind: "string-list" },
    ],
  },
  {
    key: "homeAddress",
    label: "Home address",
    fields: [
      { key: "street1", label: "Street", kind: "text" },
      { key: "street2", label: "Apartment or suite", kind: "text" },
      { key: "city", label: "City", kind: "text" },
      { key: "state", label: "State", kind: "state" },
      { key: "zipCode", label: "ZIP code", kind: "text" },
      { key: "country", label: "Country", kind: "text" },
    ],
  },
] as const satisfies readonly {
  key: string;
  label: string;
  fields: readonly Pick<
    CredentialFormField,
    "key" | "label" | "kind" | "options"
  >[];
}[];

export function personalInfoFieldKey(groupKey: string, fieldKey: string) {
  return `details.${groupKey}.${fieldKey}`;
}
